<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/home-images-01.png')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(25, 64, 96, .5)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="900"
          width="100%"
        >
          <base-heading title="스마트 건물관리서비스 Flag FMS<br><br>디지털 경제로의 대변환기</br>스마트 대한민국으로 나아가는</br>새로운 경쟁력" />

          <base-body>
            2020년 대한민국만이 전세계에서 전진하는 선진국의 모습을 보여주고 있으며,<br>
            세계를 압도할 수 있는 경쟁력의 시작은 데이터의 디지털화에 있습니다.<br>
            작은 변화의 시작이 내일을 만드는 큰 힘이 될 수 있습니다.
          </base-body>

          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn
              href="https://web.flagfms.com"
              target="_blank"
            >
              시작하기 〉
            </base-btn>

            <!-- <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn
              :ripple="false"
              class="pa-1"
              height="auto"
              text
            >
              Get Started Now
            </base-btn> -->
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },
  }
</script>
